<template>
  <table-common :name-controller="nameController"></table-common>
</template>

<script>
import { ref, watch } from "@vue/composition-api";
import { BRow, BCol, BCard } from "bootstrap-vue";
import LayoutData from "@/layouts/LayoutData";
import TableCommon from "../../Components/TableCommon";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    TableCommon,
  },

  data() {
    return {
      nameController: "PhanCapToChuc",
    };
  },
  watch: {},
  computed: {},
  created() {},
  methods: {},
  setup(props) {
    const headerData = ref(LayoutData.header.data);
    headerData.value.title = "Quản lý phân cấp tổ chức";
    document.title = `${headerData.value.title} | ${LayoutData.appInfo.data.appName}`;
    return {
      headerData,
    };
  },
};
</script>
